<ng-template #dialogContent>
  <app-sob-modal-list [sobData]="sobData"></app-sob-modal-list>
</ng-template>

<ng-template #dialogContentPdf>
  <app-modal-pdf [pdf]="pdf"></app-modal-pdf>
</ng-template>
